import { LayoutTemplate, Grid, Users, Image, Table2, MegaphoneIcon, Newspaper, ShoppingBag, Award, MessageCircle, Laptop, Menu, Mail } from 'lucide-react';

export interface Template {
  id: string;
  title: string;
  description: string;
  category: string;
  icon: typeof LayoutTemplate | typeof Grid | typeof Users | typeof Image | typeof Table2 | typeof MegaphoneIcon | typeof Newspaper | typeof ShoppingBag | typeof Award | typeof MessageCircle | typeof Laptop | typeof Menu | typeof Mail;
  pattern: string;
}

export const templates: Template[] = [
  {
    id: 'modern-hero',
    title: 'Modern Hero Section',
    description: 'A stunning hero section with gradient background and animated elements',
    category: 'hero-sections',
    icon: LayoutTemplate,
    pattern: `<!-- wp:cover {"url":"https://images.pexels.com/photos/6803523/pexels-photo-6803523.jpeg","id":3134,"isUserOverlayColor":true,"customGradient":"linear-gradient(90deg,rgb(0,76,81) 47%,rgba(255,255,255,0) 80%)","align":"full","layout":{"type":"constrained"}} -->
<div class="wp-block-cover alignfull">
  <span aria-hidden="true" class="wp-block-cover__background has-background-dim-100 has-background-dim wp-block-cover__gradient-background has-background-gradient" style="background:linear-gradient(90deg,rgb(0,76,81) 47%,rgba(255,255,255,0) 80%)"></span>
  <img class="wp-block-cover__image-background wp-image-3134" alt="" src="https://images.pexels.com/photos/6803523/pexels-photo-6803523.jpeg" data-object-fit="cover"/>
  <div class="wp-block-cover__inner-container">
    <!-- wp:spacer -->
    <div style="height:100px" aria-hidden="true" class="wp-block-spacer"></div>
    <!-- /wp:spacer -->

    <!-- wp:columns {"align":"wide","style":{"spacing":{"blockGap":{"top":"1.2rem","left":"1.2rem"}}}} -->
    <div class="wp-block-columns alignwide">
      <!-- wp:column {"verticalAlignment":"stretch","width":"60%","style":{"spacing":{"blockGap":"1.8rem"}}} -->
      <div class="wp-block-column is-vertically-aligned-stretch" style="flex-basis:60%">
        <!-- wp:heading {"level":1,"style":{"typography":{"fontStyle":"normal","fontWeight":"700","fontSize":"3.6rem"}}} -->
        <h1 class="wp-block-heading" style="font-size:3.6rem;font-style:normal;font-weight:700">Transform Your Brand with Visionary Design</h1>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"style":{"elements":{"link":{"color":{"text":"var:preset|color|white"}}}},"textColor":"white"} -->
        <p class="has-white-color has-text-color has-link-color">Step into a new era where your brand's vision meets innovative design. We specialize in creating unique visual identities that resonate with your audience, ensuring your brand stands out in a crowded marketplace.</p>
        <!-- /wp:paragraph -->

        <!-- wp:buttons {"style":{"spacing":{"blockGap":{"top":"1.2rem","left":"1.2rem"}}}} -->
        <div class="wp-block-buttons">
          <!-- wp:button {"textColor":"black","style":{"border":{"radius":"12px"},"spacing":{"padding":{"left":"2rem","right":"2rem","top":"1rem","bottom":"1rem"}},"color":{"background":"#fefefe"},"elements":{"link":{"color":{"text":"var:preset|color|black"}}}}} -->
          <div class="wp-block-button">
            <a class="wp-block-button__link has-black-color has-text-color has-background has-link-color wp-element-button" style="border-radius:12px;background-color:#fefefe;padding-top:1rem;padding-right:2rem;padding-bottom:1rem;padding-left:2rem">Schedule Meeting</a>
          </div>
          <!-- /wp:button -->

          <!-- wp:button {"textColor":"white","className":"is-style-outline","style":{"border":{"radius":"12px"},"spacing":{"padding":{"left":"2rem","right":"2rem","top":"1rem","bottom":"1rem"}},"elements":{"link":{"color":{"text":"var:preset|color|white"}}}}} -->
          <div class="wp-block-button is-style-outline">
            <a class="wp-block-button__link has-white-color has-text-color has-link-color wp-element-button" style="border-radius:12px;padding-top:1rem;padding-right:2rem;padding-bottom:1rem;padding-left:2rem">Learn More →</a>
          </div>
          <!-- /wp:button -->
        </div>
        <!-- /wp:buttons -->

        <!-- wp:spacer {"height":"20px"} -->
        <div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>
        <!-- /wp:spacer -->

        <!-- wp:columns {"align":"wide","style":{"spacing":{"blockGap":{"top":"2rem","left":"2rem"}}}} -->
        <div class="wp-block-columns alignwide">
          <!-- wp:column -->
          <div class="wp-block-column">
            <!-- wp:group {"style":{"spacing":{"blockGap":"0.6rem"}},"layout":{"type":"flex","orientation":"vertical","justifyContent":"left"}} -->
            <div class="wp-block-group">
              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"},"typography":{"fontSize":"40px","fontStyle":"normal","fontWeight":"400"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff;font-size:40px;font-style:normal;font-weight:400">98%</p>
              <!-- /wp:paragraph -->

              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff">Success Rate</p>
              <!-- /wp:paragraph -->
            </div>
            <!-- /wp:group -->
          </div>
          <!-- /wp:column -->
          <!-- wp:column -->
          <div class="wp-block-column">
            <!-- wp:group {"style":{"spacing":{"blockGap":"0.6rem"}},"layout":{"type":"flex","orientation":"vertical","justifyContent":"left"}} -->
            <div class="wp-block-group">
              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"},"typography":{"fontSize":"40px","fontStyle":"normal","fontWeight":"400"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff;font-size:40px;font-style:normal;font-weight:400">16+</p>
              <!-- /wp:paragraph -->

              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff">Years Experience</p>
              <!-- /wp:paragraph -->
            </div>
            <!-- /wp:group -->
          </div>
          <!-- /wp:column -->
          <!-- wp:column -->
          <div class="wp-block-column">
            <!-- wp:group {"style":{"spacing":{"blockGap":"0.6rem"}},"layout":{"type":"flex","orientation":"vertical","justifyContent":"left"}} -->
            <div class="wp-block-group">
              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"},"typography":{"fontSize":"40px","fontStyle":"normal","fontWeight":"400"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff;font-size:40px;font-style:normal;font-weight:400">25k</p>
              <!-- /wp:paragraph -->

              <!-- wp:paragraph {"align":"left","style":{"elements":{"link":{"color":{"text":"#ffffff"}}},"color":{"text":"#ffffff"}}} -->
              <p class="has-text-align-left has-text-color has-link-color" style="color:#ffffff">Happy Clients</p>
              <!-- /wp:paragraph -->
            </div>
            <!-- /wp:group -->
          </div>
          <!-- /wp:column -->
        </div>
        <!-- /wp:columns -->
      </div>
      <!-- /wp:column -->

      <!-- wp:column {"verticalAlignment":"stretch","width":"40%"} -->
      <div class="wp-block-column is-vertically-aligned-stretch" style="flex-basis:40%"></div>
      <!-- /wp:column -->
    </div>
    <!-- /wp:columns -->

    <!-- wp:spacer -->
    <div style="height:100px" aria-hidden="true" class="wp-block-spacer"></div>
    <!-- /wp:spacer -->
  </div>
</div>
<!-- /wp:cover -->`
  },
  {
    id: 'features-grid',
    title: 'Features Grid',
    description: 'A clean and modern features grid with icons and hover effects',
    category: 'features',
    icon: Grid,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}}},"backgroundColor":"white","layout":{"type":"constrained"}} -->
<div class="wp-block-group has-white-background-color has-background" style="padding-top:6rem;padding-bottom:6rem">
  <!-- wp:heading {"textAlign":"center","style":{"spacing":{"marginBottom":"3rem"}}} -->
  <h2 class="wp-block-heading has-text-align-center" style="margin-bottom:3rem">Why Choose Our Platform</h2>
  <!-- /wp:heading -->

  <!-- wp:columns {"align":"wide"} -->
  <div class="wp-block-columns alignwide">
    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"background","className":"hover:shadow-lg transition-shadow"} -->
      <div class="wp-block-group has-background-background-color has-background hover:shadow-lg transition-shadow" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":48,"height":48,"sizeSlug":"large"} -->
        <figure class="wp-block-image aligncenter size-large is-resized"><img src="https://api.iconify.design/lucide:wand-2.svg?color=%234f46e5" alt="AI Icon" width="48" height="48"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"large"} -->
        <h3 class="wp-block-heading has-text-align-center has-large-font-size">AI-Powered</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Transform your ideas into beautiful WordPress blocks with our advanced AI technology.</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"background","className":"hover:shadow-lg transition-shadow"} -->
      <div class="wp-block-group has-background-background-color has-background hover:shadow-lg transition-shadow" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":48,"height":48,"sizeSlug":"large"} -->
        <figure class="wp-block-image aligncenter size-large is-resized"><img src="https://api.iconify.design/lucide:layout-template.svg?color=%234f46e5" alt="Templates Icon" width="48" height="48"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"large"} -->
        <h3 class="wp-block-heading has-text-align-center has-large-font-size">Ready Templates</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Start with our professionally designed templates and customize them to your needs.</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"background","className":"hover:shadow-lg transition-shadow"} -->
      <div class="wp-block-group has-background-background-color has-background hover:shadow-lg transition-shadow" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":48,"height":48,"sizeSlug":"large"} -->
        <figure class="wp-block-image aligncenter size-large is-resized"><img src="https://api.iconify.design/lucide:code-2.svg?color=%234f46e5" alt="Code Icon" width="48" height="48"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"large"} -->
        <h3 class="wp-block-heading has-text-align-center has-large-font-size">Clean Code</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Generate optimized, standards-compliant WordPress block patterns instantly.</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->
  </div>
  <!-- /wp:columns -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'testimonials',
    title: 'Testimonials Grid',
    description: 'A modern testimonials section with user avatars and quotes',
    category: 'testimonials',
    icon: Users,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}},"color":{"background":"#f8fafc"}},"layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background" style="background-color:#f8fafc;padding-top:6rem;padding-bottom:6rem">
  <!-- wp:heading {"textAlign":"center","style":{"spacing":{"marginBottom":"3rem"}}} -->
  <h2 class="wp-block-heading has-text-align-center" style="margin-bottom:3rem">What Our Users Say</h2>
  <!-- /wp:heading -->

  <!-- wp:columns {"align":"wide"} -->
  <div class="wp-block-columns alignwide">
    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":64,"height":64,"sizeSlug":"large","className":"rounded-full"} -->
        <figure class="wp-block-image aligncenter size-large is-resized rounded-full"><img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&h=150&q=80" alt="Sarah Johnson" width="64" height="64"/></figure>
        <!-- /wp:image -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"1.125rem","lineHeight":"1.75"}}} -->
        <p class="has-text-align-center" style="font-size:1.125rem;line-height:1.75">"The AI-powered generation saves me hours of work. The patterns are clean, modern, and easy to customize."</p>
        <!-- /wp:paragraph -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"medium"} -->
        <h3 class="wp-block-heading has-text-align-center has-medium-font-size">Sarah Johnson</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"0.875rem"}}} -->
        <p class="has-text-align-center" style="font-size:0.875rem">Web Designer</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":64,"height":64,"sizeSlug":"large","className":"rounded-full"} -->
        <figure class="wp-block-image aligncenter size-large is-resized rounded-full"><img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&h=150&q=80" alt="Mike Chen" width="64" height="64"/></figure>
        <!-- /wp:image -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"1.125rem","lineHeight":"1.75"}}} -->
        <p class="has-text-align-center" style="font-size:1.125rem;line-height:1.75">"The quality of code generated is impressive. It's clean, efficient, and follows WordPress best practices perfectly."</p>
        <!-- /wp:paragraph -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"medium"} -->
        <h3 class="wp-block-heading has-text-align-center has-medium-font-size">Mike Chen</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"0.875rem"}}} -->
        <p class="has-text-align-center" style="font-size:0.875rem">WordPress Developer</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding-top:2rem;padding-right:2rem;padding-bottom:2rem;padding-left:2rem">
        <!-- wp:image {"align":"center","width":64,"height":64,"sizeSlug":"large","className":"rounded-full"} -->
        <figure class="wp-block-image aligncenter size-large is-resized rounded-full"><img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=150&h=150&q=80" alt="Emma Davis" width="64" height="64"/></figure>
        <!-- /wp:image -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"1.125rem","lineHeight":"1.75"}}} -->
        <p class="has-text-align-center" style="font-size:1.125rem;line-height:1.75">"The templates are beautiful and save me so much time. I can create professional layouts for my clients in minutes."</p>
        <!-- /wp:paragraph -->

        <!-- wp:heading {"textAlign":"center","level":3,"fontSize":"medium"} -->
        <h3 class="wp-block-heading has-text-align-center has-medium-font-size">Emma Davis</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"0.875rem"}}} -->
        <p class="has-text-align-center" style="font-size:0.875rem">Agency Owner</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->
  </div>
  <!-- /wp:columns -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'modern-header',
    title: 'Modern Header',
    description: 'A sleek and responsive header with navigation and call-to-action',
    category: 'headers',
    icon: Menu,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"1.5rem","bottom":"1.5rem"}},"position":{"type":"sticky","top":"0"}},"backgroundColor":"white","className":"shadow-sm"} -->
<div class="wp-block-group has-white-background-color has-background shadow-sm" style="padding-top:1.5rem;padding-bottom:1.5rem">
  <!-- wp:group {"layout":{"type":"flex","flexWrap":"nowrap","justifyContent":"space-between","verticalAlignment":"center"},"align":"wide"} -->
  <div class="wp-block-group alignwide">
    <!-- wp:heading {"level":1,"fontSize":"large"} -->
    <h1 class="wp-block-heading has-large-font-size">Your Brand</h1>
    <!-- /wp:heading -->

    <!-- wp:navigation {"layout":{"type":"flex","orientation":"horizontal"}} -->
    <!-- wp:navigation-link {"label":"Home","url":"#"} /-->
    <!-- wp:navigation-link {"label":"Features","url":"#"} /-->
    <!-- wp:navigation-link {"label":"Pricing","url":"#"} /-->
    <!-- wp:navigation-link {"label":"About","url":"#"} /-->
    <!-- /wp:navigation -->

    <!-- wp:buttons -->
    <div class="wp-block-buttons">
      <!-- wp:button {"backgroundColor":"black","style":{"border":{"radius":"9999px"}}} -->
      <div class="wp-block-button"><a class="wp-block-button__link has-black-background-color has-background wp-element-button" style="border-radius:9999px">Get Started</a></div>
      <!-- /wp:button -->
    </div>
    <!-- /wp:buttons -->
  </div>
  <!-- /wp:group -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'blog-post-grid',
    title: 'Blog Post Grid',
    description: 'A responsive grid layout for displaying blog posts with featured images',
    category: 'media',
    icon: Newspaper,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"4rem","bottom":"4rem"}}},"backgroundColor":"background","layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background-background-color has-background" style="padding-top:4rem;padding-bottom:4rem">
  <!-- wp:heading {"textAlign":"center","style":{"spacing":{"marginBottom":"3rem"}}} -->
  <h2 class="wp-block-heading has-text-align-center" style="margin-bottom:3rem">Latest Articles</h2>
  <!-- /wp:heading -->

  <!-- wp:columns {"align":"wide"} -->
  <div class="wp-block-columns alignwide">
    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"1rem","right":"1rem","bottom":"1rem","left":"1rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:1rem">
        <!-- wp:image {"sizeSlug":"large","style":{"border":{"radius":"0.5rem"}}} -->
        <figure class="wp-block-image size-large" style="border-radius:0.5rem"><img src="https://images.unsplash.com/photo-1661956602116-aa6865609028?auto=format&fit=crop&w=800&q=80" alt="Blog post"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"level":3,"fontSize":"large"} -->
        <h3 class="has-large-font-size">Getting Started with WordPress Blocks</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
        <p style="margin-top:0.5rem">Learn how to create stunning layouts using the WordPress block editor.</p>
        <!-- /wp:paragraph -->

        <!-- wp:group {"style":{"spacing":{"margin":{"top":"1rem"}},"typography":{"fontSize":"0.875rem"}},"textColor":"gray","layout":{"type":"flex","flexWrap":"nowrap","justifyContent":"space-between"}} -->
        <div class="wp-block-group has-gray-color has-text-color" style="margin-top:1rem;font-size:0.875rem">
          <p>John Doe</p>
          <p>5 min read</p>
        </div>
        <!-- /wp:group -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"1rem","right":"1rem","bottom":"1rem","left":"1rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:1rem">
        <!-- wp:image {"sizeSlug":"large","style":{"border":{"radius":"0.5rem"}}} -->
        <figure class="wp-block-image size-large" style="border-radius:0.5rem"><img src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80" alt="Blog post"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"level":3,"fontSize":"large"} -->
        <h3 class="has-large-font-size">Advanced Block Patterns</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
        <p style="margin-top:0.5rem">Discover how to create and use custom block patterns in your projects.</p>
        <!-- /wp:paragraph -->

        <!-- wp:group {"style":{"spacing":{"margin":{"top":"1rem"}},"typography":{"fontSize":"0.875rem"}},"textColor":"gray","layout":{"type":"flex","flexWrap":"nowrap","justifyContent":"space-between"}} -->
        <div class="wp-block-group has-gray-color has-text-color" style="margin-top:1rem;font-size:0.875rem">
          <p>Jane Smith</p>
          <p>4 min read</p>
        </div>
        <!-- /wp:group -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"1rem","right":"1rem","bottom":"1rem","left":"1rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:1rem">
        <!-- wp:image {"sizeSlug":"large","style":{"border":{"radius":"0.5rem"}}} -->
        <figure class="wp-block-image size-large" style="border-radius:0.5rem"><img src="https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=800&q=80" alt="Blog post"/></figure>
        <!-- /wp:image -->

        <!-- wp:heading {"level":3,"fontSize":"large"} -->
        <h3 class="has-large-font-size">Design Tips for Block Layouts</h3>
        <!-- /wp:heading -->

        <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
        <p style="margin-top:0.5rem">Essential design principles for creating beautiful WordPress layouts.</p>
        <!-- /wp:paragraph -->

        <!-- wp:group {"style":{"spacing":{"margin":{"top":"1rem"}},"typography":{"fontSize":"0.875rem"}},"textColor":"gray","layout":{"type":"flex","flexWrap":"nowrap","justifyContent":"space-between"}} -->
        <div class="wp-block-group has-gray-color has-text-color" style="margin-top:1rem;font-size:0.875rem">
          <p>Mike Johnson</p>
          <p>6 min read</p>
        </div>
        <!-- /wp:group -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->
  </div>
  <!-- /wp:columns -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'product-showcase',
    title: 'Product Showcase',
    description: 'A beautiful product display section with images and features',
    category: 'features',
    icon: ShoppingBag,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}}},"backgroundColor":"background","layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background-background-color has-background" style="padding-top:6rem;padding-bottom:6rem">
  <!-- wp:columns {"verticalAlignment":"center","align":"wide"} -->
  <div class="wp-block-columns alignwide are-vertically-aligned-center">
    <!-- wp:column {"verticalAlignment":"center"} -->
    <div class="wp-block-column is-vertically-aligned-center">
      <!-- wp:image {"align":"center","sizeSlug":"large","style":{"border":{"radius":"1rem"}}} -->
      <figure class="wp-block-image aligncenter size-large" style="border-radius:1rem"><img src="https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=800&q=80" alt="Product showcase"/></figure>
      <!-- /wp:image -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column {"verticalAlignment":"center"} -->
    <div class="wp-block-column is-vertically-aligned-center">
      <!-- wp:heading {"level":2,"style":{"typography":{"fontWeight":"700"}}} -->
      <h2 class="wp-block-heading" style="font-weight:700">Premium Quality Product</h2>
      <!-- /wp:heading -->

      <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"1rem","bottom":"2rem"}}}} -->
      <p style="margin-top:1rem;margin-bottom:2rem">Experience unmatched quality and design with our latest product. Crafted with attention to detail and premium materials.</p>
      <!-- /wp:paragraph -->

      <!-- wp:list {"className":"space-y-4"} -->
      <ul class="space-y-4">
        <!-- wp:list-item -->
        <li>Premium Materials</li>
        <!-- /wp:list-item -->
        <!-- wp:list-item -->
        <li>Ergonomic Design</li>
        <!-- /wp:list-item -->
        <!-- wp:list-item -->
        <li>Long-lasting Battery</li>
        <!-- /wp:list-item -->
        <!-- wp:list-item -->
        <li>1-Year Warranty</li>
        <!-- /wp:list-item -->
      </ul>
      <!-- /wp:list -->

      <!-- wp:buttons {"style":{"spacing":{"margin":{"top":"2rem"}}}} -->
      <div class="wp-block-buttons" style="margin-top:2rem">
        <!-- wp:button {"backgroundColor":"black","style":{"border":{"radius":"0.5rem"}}} -->
        <div class="wp-block-button"><a class="wp-block-button__link has-black-background-color has-background wp-element-button" style="border-radius:0.5rem">Shop Now</a></div>
        <!-- /wp:button -->
      </div>
      <!-- /wp:buttons -->
    </div>
    <!-- /wp:column -->
  </div>
  <!-- /wp:columns -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'stats-section',
    title: 'Stats Section',
    description: 'Display key metrics and achievements with a modern design',
    category: 'features',
    icon: Award,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}},"color":{"background":"linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"}},"layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background" style="background:linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);padding-top:6rem;padding-bottom:6rem">
  <!-- wp:heading {"textAlign":"center","textColor":"white"} -->
  <h2 class="wp-block-heading has-text-align-center has-white-color has-text-color">Our Impact in Numbers</h2>
  <!-- /wp:heading -->

  <!-- wp:columns {"align":"wide","style":{"spacing":{"margin":{"top":"4rem"}}}} -->
  <div class="wp-block-columns alignwide" style="margin-top:4rem">
    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:2rem">
        <!-- wp:heading {"textAlign":"center","level":3,"style":{"typography":{"fontWeight":"700","fontSize":"3rem"}}} -->
        <h3 class="wp-block-heading has-text-align-center" style="font-size:3rem;font-weight:700">10K+</h3>
        <!-- /wp:heading -->
        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Active Users</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding {"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:2rem">
        <!-- wp:heading {"textAlign":"center","level":3,"style":{"typography":{"fontWeight":"700","fontSize":"3rem"}}} -->
        <h3 class="wp-block-heading has-text-align-center" style="font-size:3rem;font-weight:700">500K+</h3>
        <!-- /wp:heading -->
        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Patterns Generated</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->

    <!-- wp:column -->
    <div class="wp-block-column">
      <!-- wp:group {"style":{"border":{"radius":"1rem"},"spacing":{"padding":{"top":"2rem","right":"2rem","bottom":"2rem","left":"2rem"}}},"backgroundColor":"white","className":"shadow-lg"} -->
      <div class="wp-block-group has-white-background-color has-background shadow-lg" style="border-radius:1rem;padding:2rem">
        <!-- wp:heading {"textAlign":"center","level":3,"style":{"typography":{"fontWeight":"700","fontSize":"3rem"}}} -->
        <h3 class="wp-block-heading has-text-align-center" style="font-size:3rem;font-weight:700">98%</h3>
        <!-- /wp:heading -->
        <!-- wp:paragraph {"align":"center"} -->
        <p class="has-text-align-center">Satisfaction Rate</p>
        <!-- /wp:paragraph -->
      </div>
      <!-- /wp:group -->
    </div>
    <!-- /wp:column -->
  </div>
  <!-- /wp:columns -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'faq-section',
    title: 'FAQ Section',
    description: 'Frequently asked questions with expandable answers',
    category: 'features',
    icon: MessageCircle,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}}},"backgroundColor":"background","layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background-background-color has-background" style="padding-top:6rem;padding-bottom:6rem">
  <!-- wp:heading {"textAlign":"center","style":{"spacing":{"marginBottom":"3rem"}}} -->
  <h2 class="wp-block-heading has-text-align-center" style="margin-bottom:3rem">Frequently Asked Questions</h2>
  <!-- /wp:heading -->

  <!-- wp:group {"style":{"spacing":{"blockGap":"1rem"}},"layout":{"type":"constrained","contentSize":"800px"}} -->
  <div class="wp-block-group">
    <!-- wp:group {"style":{"border":{"radius":"0.5rem"},"spacing":{"padding":{"top":"1.5rem","right":"1.5rem","bottom":"1.5rem","left":"1.5rem"}}},"backgroundColor":"white","className":"shadow-sm"} -->
    <div class="wp-block-group has-white-background-color has-background shadow-sm" style="border-radius:0.5rem;padding:1.5rem">
      <!-- wp:heading {"level":3,"fontSize":"medium"} -->
      <h3 class="wp-block-heading has-medium-font-size">How does the AI pattern generation work?</h3>
      <!-- /wp:heading -->

      <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
      <p style="margin-top:0.5rem">Our AI technology analyzes your requirements and generates optimized WordPress block patterns based on best practices and design principles.</p>
      <!-- /wp:paragraph -->
    </div>
    <!-- /wp:group -->

    <!-- wp:group {"style":{"border":{"radius":"0.5rem"},"spacing":{"padding":{"top":"1.5rem","right":"1.5rem","bottom":"1.5rem","left":"1.5rem"}}},"backgroundColor":"white","className":"shadow-sm"} -->
    <div class="wp-block-group has-white-background-color has-background shadow-sm" style="border-radius:0.5rem;padding:1.5rem">
      <!-- wp:heading {"level":3,"fontSize":"medium"} -->
      <h3 class="wp-block-heading has-medium-font-size">Can I customize the generated patterns?</h3>
      <!-- /wp:heading -->

      <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
      <p style="margin-top:0.5rem">Yes, all patterns can be fully customized using the WordPress block editor. You can modify colors, typography, spacing, and content to match your needs.</p>
      <!-- /wp:paragraph -->
    </div>
    <!-- /wp:group -->

    <!-- wp:group {"style":{"border":{"radius":"0.5rem"},"spacing":{"padding":{"top":"1.5rem","right":"1.5rem","bottom":"1.5rem","left":"1.5rem"}}},"backgroundColor":"white","className":"shadow-sm"} -->
    <div class="wp-block-group has-white-background-color has-background shadow-sm" style="border-radius:0.5rem;padding:1.5rem">
      <!-- wp:heading {"level":3,"fontSize":"medium"} -->
      <h3 class="wp-block-heading has-medium-font-size">Is the generated code optimized for WordPress?</h3>
      <!-- /wp:heading -->

      <!-- wp:paragraph {"style":{"spacing":{"margin":{"top":"0.5rem"}}}} -->
      <p style="margin-top:0.5rem">Absolutely! All generated patterns follow WordPress coding standards and best practices, ensuring optimal performance and compatibility.</p>
      <!-- /wp:paragraph -->
    </div>
    <!-- /wp:group -->
  </div>
  <!-- /wp:group -->
</div>
<!-- /wp:group -->`
  },
  {
    id: 'newsletter-signup',
    title: 'Newsletter Signup',
    description: 'Email subscription form with gradient background',
    category: 'call-to-action',
    icon: Mail,
    pattern: `<!-- wp:group {"style":{"spacing":{"padding":{"top":"6rem","bottom":"6rem"}},"color":{"background":"linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"}},"layout":{"type":"constrained"}} -->
<div class="wp-block-group has-background" style="background:linear-gradient(135deg, #1e293b 0%, #0f172a 100%);padding-top:6rem;padding-bottom:6rem">
  <!-- wp:group {"style":{"spacing":{"blockGap":"1rem"}},"layout":{"type":"constrained","contentSize":"600px"}} -->
  <div class="wp-block-group">
    <!-- wp:heading {"textAlign":"center","textColor":"white"} -->
    <h2 class="wp-block-heading has-text-align-center has-white-color has-text-color">Stay Updated</h2>
    <!-- /wp:heading -->

    <!-- wp:paragraph {"align":"center","textColor":"white","fontSize":"large"} -->
    <p class="has-text-align-center has-white-color has-text-color has-large-font-size">Subscribe to our newsletter for the latest updates and exclusive content.</p>
    <!-- /wp:paragraph -->

    <!-- wp:group {"style":{"spacing":{"margin":{"top":"2rem"}}},"layout":{"type":"constrained","contentSize":"400px"}} -->
    <div class="wp-block-group" style="margin-top:2rem">
      <!-- wp:form {"style":{"spacing":{"blockGap":"1rem"}}} -->
      <form class="wp-block-form">
        <!-- wp:input-field {"type":"email","required":true,"placeholder":"Enter your email","style":{"border":{"radius":"9999px"},"spacing":{"padding":{"top":"1rem","right":"1.5rem","bottom":"1rem","left":"1.5rem"}}}} /-->
        <!-- wp:button {"backgroundColor":"white","textColor":"black","width":100,"style":{"spacing":{"padding":{"top":"1rem","bottom":"1rem"}},"border":{"radius":"9999px"}}} -->
        <div class="wp-block-button has-custom-width wp-block-button__width-100"><a class="wp-block-button__link has-black-color has-white-background-color has-text-color has-background wp-element-button" style="border-radius:9999px;padding-top:1rem;padding-bottom:1rem">Subscribe Now</a></div>
        <!-- /wp:button -->
      </form>
      <!-- /wp:form -->

      <!-- wp:paragraph {"align":"center","style":{"typography":{"fontSize":"0.875rem"}},"textColor":"white"} -->
      <p class="has-text-align-center has-white-color has-text-color" style="font-size:0.875rem">We respect your privacy. Unsubscribe at any time.</p>
      <!-- /wp:paragraph -->
    </div>
    <!-- /wp:group -->
  </div>
  <!-- /wp:group -->
</div>
<!-- /wp:group -->`
  }
];